// Copyright 2026. WebPros International GmbH. All rights reserved.

import * as React from 'react';
import { StyledActions } from 'common/components/Actions/Styles';
import {
    Button,
    Icon,
    Translate,
} from '@plesk/ui-library';
import { ICONS } from 'common/constants';
import { dataCySelector } from 'common/tests/selectors';
import { TABLE_ACTIONS } from 'admin/defaultTemplate/constants/tests';
import ButtonWithConfirmation from 'common/components/ButtonWithConfirmation';
import { IDefaultTemplateResponse } from 'common/api/resources/DefaultTemplate';

export interface IDefaultTemplateProps {
    item: IDefaultTemplateResponse;
    handleEdit: () => void;
    handleRemove: () => void;
}

export const DefaultTemplateActions: React.FC<IDefaultTemplateProps> = ({
    item,
    handleEdit,
    handleRemove,
}) => (
    <StyledActions>
        <Button
            ghost={true}
            icon={<Icon name={ICONS.PENCIL} size={18} />}
            tooltip={<Translate content="defaultTemplate.tooltip.edit"/>}
            onClick={handleEdit}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.EDIT)}
        />
        <ButtonWithConfirmation
            isLoading={item.is_deleting}
            translations={{
                title: (
                    <Translate content="defaultTemplate.removePopover.title" />
                ),
                button: (
                    <Translate content="defaultTemplate.removePopover.button" />
                ),
                tooltip: (
                    <Translate content="defaultTemplate.removePopover.tooltip" />
                ),
            }}
            handleConfirm={handleRemove}
            data-cy={dataCySelector(item.id, TABLE_ACTIONS.REMOVE)}
            icon={ICONS.RECYCLE}
        />
    </StyledActions>
);